"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.{0,1}\d*))(?:Z|(\+|-)([\d|:]*))?$/;
//# sourceMappingURL=types.js.map